<template>
  <div class="download-container">
    <template v-if="isTag">
      <el-tag
        :key="downloadAddr"
        :name="index"
        closable
        @on-close="handleClose"
        >{{ showName }}</el-tag
      >
    </template>
    <template v-else>
      <el-button
        class="textBtn"
        :type="btnType"
        :plain="plain"
        :size="size"
        @click="onDownload"
      >
        {{ showName }}
        <svg-icon
          v-if="showIcon"
          class="iconShow"
          iconClass="download1"
        ></svg-icon>
      </el-button>
    </template>
  </div>
</template>

<script setup>
import { downFilesByHttp } from "@/utils/request/index";

const emits = defineEmits("onDelete");
const props = defineProps({
  showName: {
    required: false,
    type: String,
    default: "导入",
  },
  downloadAddr: {
    required: true,
    type: String,
  },
  tips: {
    required: false,
    type: String,
    default: "",
  },
  btnType: {
    required: false,
    type: String,
    default: "primary",
  },
  isTag: {
    required: false,
    type: Boolean,
    default: false,
  },
  index: {
    required: false,
    type: Number,
    default: 0,
  },
  downloadName: {
    required: false,
    type: String,
    default: null,
  },
  showIcon: {
    required: false,
    type: Boolean,
    default: false,
  },
  size: {
    required: false,
    type: String,
    default: "default",
  },
  plain: {
    required: false,
    type: Boolean,
    default: false,
  },
});

const onDownload = () => {
  downFilesByHttp(props.downloadAddr, props.downloadName);
};

const handleClose = () => {
  emits("onDelete", props.index);
};
</script>

<style lang="scss" scoped>
.textBtn:hover {
  .iconShow {
    color: #fff;
  }
}
</style>
